const getFormDataAsJson = require("../form/getFormDataAsJson");

/**
 * @param form {HTMLFormElement}
 * @return {RoiGateFormData}
 */
module.exports = function getFormDataAsRoiFormData(form) {
    return getFormDataAsJson(form);
}